// extracted by mini-css-extract-plugin
export default {"banner":"Registration_banner__ppgfj","overlay":"Registration_overlay__M-xUj","externals":"Registration_externals__RmrVF"};